export { default } from './createStyles';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/createStyles/index.js
// module id = 912
// module chunks = 2